const root = (import.meta.env.VITE_API_URL || 'http://localhost:8080').replace(/\/$/, '')

export async function api(path, options = {}) {
  const token = localStorage.getItem('nav_token')
  const response = await fetch(root + path, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...options.headers }
  })
  const data = await response.json()
  if (!response.ok) { const error = new Error(data.error || '操作失败'); error.status = response.status; error.data = data; throw error }
  return data
}

export function setSession(result) { localStorage.setItem('nav_token', result.token); localStorage.setItem('nav_user', JSON.stringify(result.user)) }
export function clearSession() { localStorage.removeItem('nav_token'); localStorage.removeItem('nav_user') }
export function getUser() { try { return JSON.parse(localStorage.getItem('nav_user')) } catch { return null } }
